import Axios from "axios";

// import JwtUtils from "../utils/jwtUtils";
import { apiHost } from "../constants/ApiConstants";
import apiClient from "./ApiClient";

export default class ApiGameAnalytics {
  static async getAnalyticsCountUserMonth(userId) {
    return await apiClient
      .get(`${apiHost}/analytics/count/month/user/${userId}`, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }
  static async getAnalytics(tourId, page, pageSize, sortColumn) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortColumn: sortColumn,
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  // Variante publique de `getAnalytics` : même forme de réponse, mais servie
  // par une route sans authentification et expurgée des données personnelles
  // des participants. C'est celle qu'utilise le classement, consultable sans
  // compte.
  static async getPublicAnalytics(tourId, page, pageSize, sortColumn) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}/public`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortColumn: sortColumn,
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async updateAnalytic(analyticId, body) {
    // const tokens = await JwtUtils.getValidTokens();
    // if (!tokens) {
    //   return { status: null, data: null };
    // }
    // const authHeader = "Bearer " + tokens.accessToken;

    return await apiClient
      .post(`${apiHost}/analytic/${analyticId}`, body, {
        // headers: { Authorization: authHeader },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response.status,
            data: error.response.data,
          };
        }

        return errorLog;
      });
  }

  static async getMapTilesRequests(userId, startDate, endDate) {
    return await apiClient
      .get(
        `${apiHost}/analytic/mapTilesRequests/${userId}/${startDate.toISOString()}/${endDate.toISOString()}`,
        {}
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getMapTilesRequestsTotalForUser(userId) {
    return await apiClient
      .get(`${apiHost}/analytic/mapTilesRequests/${userId}`, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getMapTilesRequestsTotalThreeMonth() {
    return await apiClient
      .get(`${apiHost}/analytic/mapTilesRequests/total/threeMonth`, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getAnalyticsTwelveMonths(tourId) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}/twelve-months`, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getTeamPhotosForTour(tourId, page, pageSize, sortColumn) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}/team-photos`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortColumn: sortColumn,
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getSessions(tourId, page, pageSize, sortColumn) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}/sessions`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortColumn: sortColumn,
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  // Variante publique de `getSessions`, pour le suivi en direct : pas de photos
  // d'équipe, pas de données personnelles, pas de contrôle de propriété.
  //
  // `since` / `until` bornent la fenêtre de l'enregistrement en cours : sans
  // elles, le back scanne tout l'historique du parcours à chaque tour de
  // polling pour un résultat que le front jetterait de toute façon.
  static async getPublicSessions(
    tourId,
    page,
    pageSize,
    sortColumn,
    since,
    until
  ) {
    return await apiClient
      .get(`${apiHost}/analytics/${tourId}/sessions/public`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortColumn: sortColumn,
          ...(since ? { since } : {}),
          ...(until ? { until } : {}),
        },
      })
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async deleteTeamPhoto(teamPhotoId) {
    return await apiClient
      .delete(`${apiHost}/analytics/team-photo/${teamPhotoId}`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };
        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }
}
